import React from "react";
import {Button, Grid, Typography} from "@mui/material";
import View from "../../components/View"
import Headline from "../../components/Headline";

// @ts-ignore
function Welcome(props) {

    const version = process.env.REACT_APP_VERSION_INFO
    const {showBackButton} = props;

    showBackButton(false);

    return (
        <>
            <View>
                <Grid container rowSpacing={1} columnSpacing={2.75} sx={{mb: 2}}>
                    <Grid item xs={12}>
                        <Button sx={{width: '90%'}} variant="outlined" href="/nitrox">Nitrox</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button sx={{width: '90%'}} variant="outlined" href="/trimix">Trimix</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button disabled sx={{width: '90%'}} variant="outlined" href="/top-up-mix">Top up mix</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button disabled sx={{width: '90%'}} variant="outlined" href="/heliair">Heliair</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button sx={{width: '90%'}} variant="outlined" href="/best-mix">Best Mix</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button sx={{width: '90%'}} variant="outlined" href="/mod">Maximum Operating Depth</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button sx={{width: '90%'}} variant="outlined" href="/ead">Equivalent Air Depth</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button sx={{width: '90%'}} variant="outlined" href="/end">Equivalent Narcotic Depth</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button sx={{width: '90%'}} variant="outlined" href="/about">About</Button>
                    </Grid>
                </Grid>
            </View>
            <Grid container rowSpacing={1} columnSpacing={2.75}>
                <Grid item xs={12}>
                    <View>
                        <Headline text="Warning"/>
                        <Typography mt={2}>
                            This application is not a substitute for proper training and should not be used as a
                            substitute
                            for proper dive planning or the primary blending and planning methods taught during
                            training.
                        </Typography>
                        <Typography mt={2}>
                            Please do not attempt to handle high pressure oxygen or fill SCUBA cylinders without
                            proper training.
                        </Typography>
                        <Typography mt={2}>
                            Training for Nitrox blending is available from various SCUBA Diving training agencies
                            including CMAS, PADI, SSI, TDI/SDI, NAUI, GUE and others.
                        </Typography>
                    </View>
                    <Typography sx={{color: 'lightgray', mt: 1}}>version: {version}</Typography>
                </Grid>
            </Grid>
        </>
    );
}

export default Welcome;